import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
// import DashboardAppPage from './pages/DashboardAppPage';
import Stats from './pages/Zodiac/Stats';
import LuckyDraw from './pages/LuckyDraw';
import DigitalMessage from './pages/Whatsapp/DigitalMessage';
import SettingPage from './pages/SettingPage';
import EventPage from './pages/EventPage';
import AdminRunners from './pages/AdminRunners';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/login" />, index: true },
        // {
        //   path: 'login',
        //   element: <LoginPage />,
        // },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'luckydraw', element: <LuckyDraw /> },
        { path: 'message', element: <DigitalMessage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'zodiac', element: <Stats /> },
        { path: 'setting', element: <SettingPage /> },
        { path: 'event', element: <EventPage /> },
        { path: 'runners/:eventId', element: <AdminRunners /> },
      ],
    },

    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },

    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
